export default __webpack_public_path__ + "static/media/sale1_revealed_gold_front_transpparent.5ebe7ef6.png";